import { AREA_MASTER } from "constants/areaMaster";

import type { Props } from "../../props";
import type { GroupedPrefectureMasterRecord } from "../../types/groupedPrefectureMasterRecord";

const OTHER_AREA_CODE = AREA_MASTER.others.code;
const OTHER_REQUEST_CODE = "99";

type Input = GroupedPrefectureMasterRecord[];
type SelectedPrefectures = string[] | undefined;
type Output = Props["groupedPrefectures"];
type ConvertToWithState = (
  input: Input,
  selectedPrefectures: SelectedPrefectures
) => Output;

export const convertToWithState: ConvertToWithState = (
  input,
  selectedPrefectures = []
) => {
  const selectedPrefectureSet = new Set(selectedPrefectures);

  return input.reduce<Output>((previousValue, currentValue) => {
    const { code: areaCode, prefectures } = currentValue;
    const hasPrefectures = prefectures.length > 0;
    const isCurrentArea = areaCode === OTHER_AREA_CODE;
    const hasOtherArea = selectedPrefectureSet.has(OTHER_REQUEST_CODE) ?? false;
    const isAllIncludedPrefectureChecked =
      hasPrefectures &&
      prefectures.every(({ code }) => selectedPrefectureSet.has(code));
    const areaWithState: Output[number] = {
      ...currentValue,
      isAreaChecked:
        (isCurrentArea && hasOtherArea) || isAllIncludedPrefectureChecked,
      isOpened: false,
      prefectures: prefectures.map((prefecture) => {
        const { code: prefectureCode } = prefecture;
        return {
          ...prefecture,
          isPrefectureChecked:
            selectedPrefectureSet.has(prefectureCode) ?? false,
        };
      }),
    };
    return [...previousValue, areaWithState];
  }, []);
};
